export default "__VITE_ASSET__9ca2f5fc__"